import React from "react"
import PropTypes from "prop-types"
import { Progress } from "antd"
import styles from "../../UploadFile/index.module.css"

/**
 * UploadProgress Component
 * Displays upload progress bar with percentage
 * Follows Single Responsibility Principle
 */
const UploadProgress = ({ progress }) => {
  return (
    <div className={styles.progressContainer}>
      <Progress
        percent={progress}
        size="small"
        status="active"
        showInfo={false}
        strokeColor="#1677ff"
        trailColor="#f0f0f0"
        style={{ width: "60%" }}
      />
      <span className={styles.progressText}>{progress}% done</span>
    </div>
  )
}

UploadProgress.propTypes = {
  progress: PropTypes.number.isRequired
}

export default UploadProgress
